export default function TechnologyHero() {
  return (
    <section className="relative min-h-[85vh] flex items-center justify-center px-6 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/3cbabd3a600e068994c2232cffa5ac41.jpg"
          alt="循環型陸上養殖技術"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto text-center">
        <div className="inline-flex items-center px-5 py-2 rounded-full bg-white/95 backdrop-blur-sm mb-8">
          <i className="ri-flask-line text-[#2D7A3E] text-lg mr-2"></i>
          <span className="text-[#2D7A3E] text-sm font-semibold whitespace-nowrap">先進的な養殖技術</span>
        </div>
        
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-8 leading-tight">
          循環型陸上養殖<br />
          システム
        </h1>
        
        <p className="text-xl md:text-2xl text-white/95 mb-12 max-w-3xl mx-auto leading-relaxed">
          筑波大学の研究技術を基盤とした、環境負荷を最小限に抑える<br />
          持続可能な水産生産システムです。
        </p>

        <div className="flex flex-wrap justify-center gap-6">
          <div className="bg-white/95 backdrop-blur-sm px-8 py-6 rounded-xl">
            <p className="text-4xl font-bold text-[#2D7A3E] mb-1">90%+</p>
            <p className="text-sm text-gray-700 whitespace-nowrap">水使用量削減</p>
          </div>
          <div className="bg-white/95 backdrop-blur-sm px-8 py-6 rounded-xl">
            <p className="text-4xl font-bold text-[#2D7A3E] mb-1">Zero</p>
            <p className="text-sm text-gray-700 whitespace-nowrap">環境排水</p>
          </div>
          <div className="bg-white/95 backdrop-blur-sm px-8 py-6 rounded-xl">
            <p className="text-4xl font-bold text-[#2D7A3E] mb-1">365日</p>
            <p className="text-sm text-gray-700 whitespace-nowrap">安定生産</p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}